<template>
  <v-autocomplete hide-details @input="event => { emitChange(event) }" :items="beltList" v-model="selectedBelt"
    :label="$t('message.select_belt')" item-text="text" item-value="value" clearable outlined dense>
    <template v-slot:item="data">
      <div style="display: flex; align-items: center;">
        <BeltSVG :colors="data.item.colors" />
        <span class="ml-2 mt-1" v-html="data.item.text"></span>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
import BeltSVG from '@/components/displays/BeltSVG.vue';

export default {
  components: {
    BeltSVG,
  },
  data() {
    return {
      selectedBelt: "",
      props: {
        value: null,
        belts: null,
      },
      beltList: [
        // White Belt Monthly
        {
          text: this.$t("message.white_m_1"),
          value: "white_m_1",
          colors: ["#FFFFFF", "#000000", "#000000", "#000000", "#000000", "#FFFFFF"],
        },
        {
          text: this.$t("message.white_m_2"),
          value: "white_m_2",
          colors: ["#FFFFFF", "#000000", "#000000", "#000000", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.white_m_3"),
          value: "white_m_3",
          colors: ["#FFFFFF", "#000000", "#000000", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.white_m_4"),
          value: "white_m_4",
          colors: ["#FFFFFF", "#000000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.white_m_5"),
          value: "white_m_5",
          colors: ["#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.white_m_6"),
          value: "white_m_6",
          colors: ["#FFFFFF", "#FF0000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
          //         white        red       white       white     white       white (belt)
        },

        // Gray/White Belt Monthly
        {
          text: this.$t("message.gray_white_m_1"),
          value: "gray_white_m_1",
          colors: ["#808080", "#000000", "#000000", "#000000", "#000000", "#FFFFFF"],
        },
        {
          text: this.$t("message.gray_white_m_2"),
          value: "gray_white_m_2",
          colors: ["#808080", "#000000", "#000000", "#000000", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.gray_white_m_3"),
          value: "gray_white_m_3",
          colors: ["#808080", "#000000", "#000000", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.gray_white_m_4"),
          value: "gray_white_m_4",
          colors: ["#808080", "#000000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.gray_white_m_5"),
          value: "gray_white_m_5",
          colors: ["#808080", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.gray_white_m_6"),
          value: "gray_white_m_6",
          colors: ["#808080", "#FF0000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },

        // Gray Belt Monthly
        {
          text: this.$t("message.gray_m_1"),
          value: "gray_m_1",
          colors: ["#808080", "#000000", "#000000", "#000000", "#000000", "#808080"],
        },
        {
          text: this.$t("message.gray_m_2"),
          value: "gray_m_2",
          colors: ["#808080", "#000000", "#000000", "#000000", "#FFFFFF", "#808080"],
        },
        {
          text: this.$t("message.gray_m_3"),
          value: "gray_m_3",
          colors: ["#808080", "#000000", "#000000", "#FFFFFF", "#FFFFFF", "#808080"],
        },
        {
          text: this.$t("message.gray_m_4"),
          value: "gray_m_4",
          colors: ["#808080", "#000000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#808080"],
        },
        {
          text: this.$t("message.gray_m_5"),
          value: "gray_m_5",
          colors: ["#808080", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#808080"],
        },
        {
          text: this.$t("message.gray_m_6"),
          value: "gray_m_6",
          colors: ["#808080", "#FF0000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#808080"],
        },
        {
          text: this.$t("message.gray_m_7"),
          value: "gray_m_7",
          colors: ["#808080", "#FF0000", "#FF0000", "#FFFFFF", "#FFFFFF", "#808080"],
        },
        {
          text: this.$t("message.gray_m_8"),
          value: "gray_m_8",
          colors: ["#808080", "#FF0000", "#FF0000", "#FF0000", "#FFFFFF", "#808080"],
        },
        {
          text: this.$t("message.gray_m_9"),
          value: "gray_m_9",
          colors: ["#808080", "#FF0000", "#FF0000", "#FF0000", "#FF0000", "#808080"],
        },
        {
          text: this.$t("message.gray_m_10"),
          value: "gray_m_10",
          colors: ["#808080", "#E2D600", "#FF0000", "#FF0000", "#FF0000", "#808080"],
        },
        {
          text: this.$t("message.gray_m_11"),
          value: "gray_m_11",
          colors: ["#808080", "#E2D600", "#E2D600", "#FF0000", "#FF0000", "#808080"],
        },
        {
          text: this.$t("message.gray_m_12"),
          value: "gray_m_12",
          colors: ["#808080", "#E2D600", "#E2D600", "#E2D600", "#FF0000", "#808080"],
        },

        // Gray/Black Belt Monthly
        {
          text: this.$t("message.gray_black_m_1"),
          value: "gray_black_m_1",
          colors: ["#808080", "#000000", "#000000", "#000000", "#000000", "#000000"],
        },
        {
          text: this.$t("message.gray_black_m_2"),
          value: "gray_black_m_2",
          colors: ["#808080", "#000000", "#000000", "#000000", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.gray_black_m_3"),
          value: "gray_black_m_3",
          colors: ["#808080", "#000000", "#000000", "#FFFFFF", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.gray_black_m_4"),
          value: "gray_black_m_4",
          colors: ["#808080", "#000000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.gray_black_m_5"),
          value: "gray_black_m_5",
          colors: ["#808080", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.gray_black_m_6"),
          value: "gray_black_m_6",
          colors: ["#808080", "#FF0000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.gray_black_m_7"),
          value: "gray_black_m_7",
          colors: ["#808080", "#FF0000", "#FF0000", "#FFFFFF", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.gray_black_m_8"),
          value: "gray_black_m_8",
          colors: ["#808080", "#FF0000", "#FF0000", "#FF0000", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.gray_black_m_9"),
          value: "gray_black_m_9",
          colors: ["#808080", "#FF0000", "#FF0000", "#FF0000", "#FF0000", "#000000"],
        },
        {
          text: this.$t("message.gray_black_m_10"),
          value: "gray_black_m_10",
          colors: ["#808080", "#E2D600", "#FF0000", "#FF0000", "#FF0000", "#000000"],
        },
        {
          text: this.$t("message.gray_black_m_11"),
          value: "gray_black_m_11",
          colors: ["#808080", "#E2D600", "#E2D600", "#FF0000", "#FF0000", "#000000"],
        },
        {
          text: this.$t("message.gray_black_m_12"),
          value: "gray_black_m_12",
          colors: ["#808080", "#E2D600", "#E2D600", "#E2D600", "#FF0000", "#000000"],
        },



        // Yellow White Belt Monthly
        {
          text: this.$t("message.yellow_white_m_1"),
          value: "yellow_white_m_1",
          colors: ["#E2D600", "#000000", "#000000", "#000000", "#000000", "#FFFFFF"],
        },
        {
          text: this.$t("message.yellow_white_m_2"),
          value: "yellow_white_m_2",
          colors: ["#E2D600", "#000000", "#000000", "#000000", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.yellow_white_m_3"),
          value: "yellow_white_m_3",
          colors: ["#E2D600", "#000000", "#000000", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.yellow_white_m_4"),
          value: "yellow_white_m_4",
          colors: ["#E2D600", "#000000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.yellow_white_m_5"),
          value: "yellow_white_m_5",
          colors: ["#E2D600", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.yellow_white_m_6"),
          value: "yellow_white_m_6",
          colors: ["#E2D600", "#FF0000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.yellow_white_m_7"),
          value: "yellow_white_m_7",
          colors: ["#E2D600", "#FF0000", "#FF0000", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.yellow_white_m_8"),
          value: "yellow_white_m_8",
          colors: ["#E2D600", "#FF0000", "#FF0000", "#FF0000", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.yellow_white_m_9"),
          value: "yellow_white_m_9",
          colors: ["#E2D600", "#FF0000", "#FF0000", "#FF0000", "#FF0000", "#FFFFFF"],
        },
        {
          text: this.$t("message.yellow_white_m_10"),
          value: "yellow_white_m_10",
          colors: ["#E2D600", "#FFA500", "#FF0000", "#FF0000", "#FF0000", "#FFFFFF"],
        },
        {
          text: this.$t("message.yellow_white_m_11"),
          value: "yellow_white_m_11",
          colors: ["#E2D600", "#FFA500", "#FFA500", "#FF0000", "#FF0000", "#FFFFFF"],
        },
        {
          text: this.$t("message.yellow_white_m_12"),
          value: "yellow_white_m_12",
          colors: ["#E2D600", "#FFA500", "#FFA500", "#FFA500", "#FF0000", "#FFFFFF"],
        },
        //Yellow Belt Monthly
        {
          text: this.$t("message.yellow_m_1"),
          value: "yellow_m_1",
          colors: ["#E2D600", "#000000", "#000000", "#000000", "#000000", "#E2D600"],
        },
        {
          text: this.$t("message.yellow_m_2"),
          value: "yellow_m_2",
          colors: ["#E2D600", "#000000", "#000000", "#000000", "#FFFFFF", "#E2D600"],
        },
        {
          text: this.$t("message.yellow_m_3"),
          value: "yellow_m_3",
          colors: ["#E2D600", "#000000", "#000000", "#FFFFFF", "#FFFFFF", "#E2D600"],
        },
        {
          text: this.$t("message.yellow_m_4"),
          value: "yellow_m_4",
          colors: ["#E2D600", "#000000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#E2D600"],
        },
        {
          text: this.$t("message.yellow_m_5"),
          value: "yellow_m_5",
          colors: ["#E2D600", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#E2D600"],
        },
        {
          text: this.$t("message.yellow_m_6"),
          value: "yellow_m_6",
          colors: ["#E2D600", "#FF0000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#E2D600"],
        },
        {
          text: this.$t("message.yellow_m_7"),
          value: "yellow_m_7",
          colors: ["#E2D600", "#FF0000", "#FF0000", "#FFFFFF", "#FFFFFF", "#E2D600"],
        },
        {
          text: this.$t("message.yellow_m_8"),
          value: "yellow_m_8",
          colors: ["#E2D600", "#FF0000", "#FF0000", "#FF0000", "#FFFFFF", "#E2D600"],
        },
        {
          text: this.$t("message.yellow_m_9"),
          value: "yellow_m_9",
          colors: ["#E2D600", "#FF0000", "#FF0000", "#FF0000", "#FF0000", "#E2D600"],
        },
        {
          text: this.$t("message.yellow_m_10"),
          value: "yellow_m_10",
          colors: ["#E2D600", "#FFA500", "#FF0000", "#FF0000", "#FF0000", "#E2D600"],
        },
        {
          text: this.$t("message.yellow_m_11"),
          value: "yellow_m_11",
          colors: ["#E2D600", "#FFA500", "#FFA500", "#FF0000", "#FF0000", "#E2D600"],
        },
        {
          text: this.$t("message.yellow_m_12"),
          value: "yellow_m_12",
          colors: ["#E2D600", "#FFA500", "#FFA500", "#FFA500", "#FF0000", "#E2D600"],
        },
        // Yellow black Belt Montly
        {
          text: this.$t("message.yellow_black_m_1"),
          value: "yellow_black_m_1",
          colors: ["#E2D600", "#000000", "#000000", "#000000", "#000000", "#000000"],
        },
        {
          text: this.$t("message.yellow_black_m_2"),
          value: "yellow_black_m_2",
          colors: ["#E2D600", "#000000", "#000000", "#000000", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.yellow_black_m_3"),
          value: "yellow_black_m_3",
          colors: ["#E2D600", "#000000", "#000000", "#FFFFFF", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.yellow_black_m_4"),
          value: "yellow_black_m_4",
          colors: ["#E2D600", "#000000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.yellow_black_m_5"),
          value: "yellow_black_m_5",
          colors: ["#E2D600", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.yellow_black_m_6"),
          value: "yellow_black_m_6",
          colors: ["#E2D600", "#FF0000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.yellow_black_m_7"),
          value: "yellow_black_m_7",
          colors: ["#E2D600", "#FF0000", "#FF0000", "#FFFFFF", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.yellow_black_m_8"),
          value: "yellow_black_m_8",
          colors: ["#E2D600", "#FF0000", "#FF0000", "#FF0000", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.yellow_black_m_9"),
          value: "yellow_black_m_9",
          colors: ["#E2D600", "#FF0000", "#FF0000", "#FF0000", "#FF0000", "#000000"],
        },
        {
          text: this.$t("message.yellow_black_m_10"),
          value: "yellow_black_m_10",
          colors: ["#E2D600", "#FFA500", "#FF0000", "#FF0000", "#FF0000", "#000000"],
        },
        {
          text: this.$t("message.yellow_black_m_11"),
          value: "yellow_black_m_11",
          colors: ["#E2D600", "#FFA500", "#FFA500", "#FF0000", "#FF0000", "#000000"],
        },
        {
          text: this.$t("message.yellow_black_m_12"),
          value: "yellow_black_m_12",
          colors: ["#E2D600", "#FFA500", "#FFA500", "#FFA500", "#FF0000", "#000000"],
        },
        // Orange/White Belt Monthly
        {
          text: this.$t("message.orange_white_m_1"),
          value: "orange_white_m_1",
          colors: ["#FFA500", "#000000", "#000000", "#000000", "#000000", "#FFFFFF"],
        },
        {
          text: this.$t("message.orange_white_m_2"),
          value: "orange_white_m_2",
          colors: ["#FFA500", "#000000", "#000000", "#000000", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.orange_white_m_3"),
          value: "orange_white_m_3",
          colors: ["#FFA500", "#000000", "#000000", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.orange_white_m_4"),
          value: "orange_white_m_4",
          colors: ["#FFA500", "#000000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.orange_white_m_5"),
          value: "orange_white_m_5",
          colors: ["#FFA500", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.orange_white_m_6"),
          value: "orange_white_m_6",
          colors: ["#FFA500", "#FF0000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.orange_white_m_7"),
          value: "orange_white_m_7",
          colors: ["#FFA500", "#FF0000", "#FF0000", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.orange_white_m_8"),
          value: "orange_white_m_8",
          colors: ["#FFA500", "#FF0000", "#FF0000", "#FF0000", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.orange_white_m_9"),
          value: "orange_white_m_9",
          colors: ["#FFA500", "#FF0000", "#FF0000", "#FF0000", "#FF0000", "#FFFFFF"],
        },
        {
          text: this.$t("message.orange_white_m_10"),
          value: "orange_white_m_10",
          colors: ["#FFA500", "#008000", "#FF0000", "#FF0000", "#FF0000", "#FFFFFF"],
        },
        {
          text: this.$t("message.orange_white_m_11"),
          value: "orange_white_m_11",
          colors: ["#FFA500", "#008000", "#008000", "#FF0000", "#FF0000", "#FFFFFF"],
        },
        {
          text: this.$t("message.orange_white_m_12"),
          value: "orange_white_m_12",
          colors: ["#FFA500", "#008000", "#008000", "#008000", "#FF0000", "#FFFFFF"],
        },
        // Orange Belt Monthly
        {
          text: this.$t("message.orange_m_1"),
          value: "orange_m_1",
          colors: ["#FFA500", "#000000", "#000000", "#000000", "#000000", "#FFA500"],
        },
        {
          text: this.$t("message.orange_m_2"),
          value: "orange_m_2",
          colors: ["#FFA500", "#000000", "#000000", "#000000", "#FFFFFF", "#FFA500"],
        },
        {
          text: this.$t("message.orange_m_3"),
          value: "orange_m_3",
          colors: ["#FFA500", "#000000", "#000000", "#FFFFFF", "#FFFFFF", "#FFA500"],
        },
        {
          text: this.$t("message.orange_m_4"),
          value: "orange_m_4",
          colors: ["#FFA500", "#000000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFA500"],
        },
        {
          text: this.$t("message.orange_m_5"),
          value: "orange_m_5",
          colors: ["#FFA500", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFA500"],
        },
        {
          text: this.$t("message.orange_m_6"),
          value: "orange_m_6",
          colors: ["#FFA500", "#FF0000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFA500"],
        },
        {
          text: this.$t("message.orange_m_7"),
          value: "orange_m_7",
          colors: ["#FFA500", "#FF0000", "#FF0000", "#FFFFFF", "#FFFFFF", "#FFA500"],
        },
        {
          text: this.$t("message.orange_m_8"),
          value: "orange_m_8",
          colors: ["#FFA500", "#FF0000", "#FF0000", "#FF0000", "#FFFFFF", "#FFA500"],
        },
        {
          text: this.$t("message.orange_m_9"),
          value: "orange_m_9",
          colors: ["#FFA500", "#FF0000", "#FF0000", "#FF0000", "#FF0000", "#FFA500"],
        },
        {
          text: this.$t("message.orange_m_10"),
          value: "orange_m_10",
          colors: ["#FFA500", "#008000", "#FF0000", "#FF0000", "#FF0000", "#FFA500"],
        },
        {
          text: this.$t("message.orange_m_11"),
          value: "orange_m_11",
          colors: ["#FFA500", "#008000", "#008000", "#FF0000", "#FF0000", "#FFA500"],
        },
        {
          text: this.$t("message.orange_m_12"),
          value: "orange_m_12",
          colors: ["#FFA500", "#008000", "#008000", "#008000", "#FF0000", "#FFA500"],
        },
        // Orange/Black Belt Monthly
        {
          text: this.$t("message.orange_black_m_1"),
          value: "orange_black_m_1",
          colors: ["#FFA500", "#000000", "#000000", "#000000", "#000000", "#000000"],
        },
        {
          text: this.$t("message.orange_black_m_2"),
          value: "orange_black_m_2",
          colors: ["#FFA500", "#000000", "#000000", "#000000", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.orange_black_m_3"),
          value: "orange_black_m_3",
          colors: ["#FFA500", "#000000", "#000000", "#FFFFFF", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.orange_black_m_4"),
          value: "orange_black_m_4",
          colors: ["#FFA500", "#000000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.orange_black_m_5"),
          value: "orange_black_m_5",
          colors: ["#FFA500", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.orange_black_m_6"),
          value: "orange_black_m_6",
          colors: ["#FFA500", "#FF0000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.orange_black_m_7"),
          value: "orange_black_m_7",
          colors: ["#FFA500", "#FF0000", "#FF0000", "#FFFFFF", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.orange_black_m_8"),
          value: "orange_black_m_8",
          colors: ["#FFA500", "#FF0000", "#FF0000", "#FF0000", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.orange_black_m_9"),
          value: "orange_black_m_9",
          colors: ["#FFA500", "#FF0000", "#FF0000", "#FF0000", "#FF0000", "#000000"],
        },
        {
          text: this.$t("message.orange_black_m_10"),
          value: "orange_black_m_10",
          colors: ["#FFA500", "#008000", "#FF0000", "#FF0000", "#FF0000", "#000000"],
        },
        {
          text: this.$t("message.orange_black_m_11"),
          value: "orange_black_m_11",
          colors: ["#FFA500", "#008000", "#008000", "#FF0000", "#FF0000", "#000000"],
        },
        {
          text: this.$t("message.orange_black_m_12"),
          value: "orange_black_m_12",
          colors: ["#FFA500", "#008000", "#008000", "#008000", "#FF0000", "#000000"],
        },
        // Green / white Belt Monthly
        // Green/White Belt Monthly
        {
          text: this.$t("message.green_white_m_1"),
          value: "green_white_m_1",
          colors: ["#008000", "#000000", "#000000", "#000000", "#000000", "#FFFFFF"],
        },
        {
          text: this.$t("message.green_white_m_2"),
          value: "green_white_m_2",
          colors: ["#008000", "#000000", "#000000", "#000000", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.green_white_m_3"),
          value: "green_white_m_3",
          colors: ["#008000", "#000000", "#000000", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.green_white_m_4"),
          value: "green_white_m_4",
          colors: ["#008000", "#000000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.green_white_m_5"),
          value: "green_white_m_5",
          colors: ["#008000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.green_white_m_6"),
          value: "green_white_m_6",
          colors: ["#008000", "#FF0000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.green_white_m_7"),
          value: "green_white_m_7",
          colors: ["#008000", "#FF0000", "#FF0000", "#FFFFFF", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.green_white_m_8"),
          value: "green_white_m_8",
          colors: ["#008000", "#FF0000", "#FF0000", "#FF0000", "#FFFFFF", "#FFFFFF"],
        },
        {
          text: this.$t("message.green_white_m_9"),
          value: "green_white_m_9",
          colors: ["#008000", "#FF0000", "#FF0000", "#FF0000", "#FF0000", "#FFFFFF"],
        },
        {
          text: this.$t("message.green_white_m_10"),
          value: "green_white_m_10",
          colors: ["#008000", "#0000FF", "#FF0000", "#FF0000", "#FF0000", "#FFFFFF"],
        },
        {
          text: this.$t("message.green_white_m_11"),
          value: "green_white_m_11",
          colors: ["#008000", "#0000FF", "#0000FF", "#FF0000", "#FF0000", "#FFFFFF"],
        },
        {
          text: this.$t("message.green_white_m_12"),
          value: "green_white_m_12",
          colors: ["#008000", "#0000FF", "#0000FF", "#0000FF", "#FF0000", "#FFFFFF"],
        },
        // Green Belt Monthly

        {
          text: this.$t("message.green_m_1"),
          value: "green_m_1",
          colors: ["#008000", "#000000", "#000000", "#000000", "#000000", "#008000"],
        },
        {
          text: this.$t("message.green_m_2"),
          value: "green_m_2",
          colors: ["#008000", "#000000", "#000000", "#000000", "#FFFFFF", "#008000"],
        },
        {
          text: this.$t("message.green_m_3"),
          value: "green_m_3",
          colors: ["#008000", "#000000", "#000000", "#FFFFFF", "#FFFFFF", "#008000"],
        },
        {
          text: this.$t("message.green_m_4"),
          value: "green_m_4",
          colors: ["#008000", "#000000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#008000"],
        },
        {
          text: this.$t("message.green_m_5"),
          value: "green_m_5",
          colors: ["#008000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#008000"],
        },
        {
          text: this.$t("message.green_m_6"),
          value: "green_m_6",
          colors: ["#008000", "#FF0000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#008000"],
        },
        {
          text: this.$t("message.green_m_7"),
          value: "green_m_7",
          colors: ["#008000", "#FF0000", "#FF0000", "#FFFFFF", "#FFFFFF", "#008000"],
        },
        {
          text: this.$t("message.green_m_8"),
          value: "green_m_8",
          colors: ["#008000", "#FF0000", "#FF0000", "#FF0000", "#FFFFFF", "#008000"],
        },
        {
          text: this.$t("message.green_m_9"),
          value: "green_m_9",
          colors: ["#008000", "#FF0000", "#FF0000", "#FF0000", "#FF0000", "#008000"],
        },
        {
          text: this.$t("message.green_m_10"),
          value: "green_m_10",
          colors: ["#008000", "#0000FF", "#FF0000", "#FF0000", "#FF0000", "#008000"],
        },
        {
          text: this.$t("message.green_m_11"),
          value: "green_m_11",
          colors: ["#008000", "#0000FF", "#0000FF", "#FF0000", "#FF0000", "#008000"],
        },
        {
          text: this.$t("message.green_m_12"),
          value: "green_m_12",
          colors: ["#008000", "#0000FF", "#0000FF", "#0000FF", "#FF0000", "#008000"],
        },
        // Green/Black Belt Weekly
        // Green/Black Belt Monthly
        {
          text: this.$t("message.green_black_m_1"),
          value: "green_black_m_1",
          colors: ["#008000", "#000000", "#000000", "#000000", "#000000", "#000000"],
        },
        {
          text: this.$t("message.green_black_m_2"),
          value: "green_black_m_2",
          colors: ["#008000", "#000000", "#000000", "#000000", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.green_black_m_3"),
          value: "green_black_m_3",
          colors: ["#008000", "#000000", "#000000", "#FFFFFF", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.green_black_m_4"),
          value: "green_black_m_4",
          colors: ["#008000", "#000000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.green_black_m_5"),
          value: "green_black_m_5",
          colors: ["#008000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.green_black_m_6"),
          value: "green_black_m_6",
          colors: ["#008000", "#FF0000", "#FFFFFF", "#FFFFFF", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.green_black_m_7"),
          value: "green_black_m_7",
          colors: ["#008000", "#FF0000", "#FF0000", "#FFFFFF", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.green_black_m_8"),
          value: "green_black_m_8",
          colors: ["#008000", "#FF0000", "#FF0000", "#FF0000", "#FFFFFF", "#000000"],
        },
        {
          text: this.$t("message.green_black_m_9"),
          value: "green_black_m_9",
          colors: ["#008000", "#FF0000", "#FF0000", "#FF0000", "#FF0000", "#000000"],
        },
        {
          text: this.$t("message.green_black_m_10"),
          value: "green_black_m_10",
          colors: ["#008000", "#0000FF", "#FF0000", "#FF0000", "#FF0000", "#000000"],
        },
        {
          text: this.$t("message.green_black_m_11"),
          value: "green_black_m_11",
          colors: ["#008000", "#0000FF", "#0000FF", "#FF0000", "#FF0000", "#000000"],
        },
        {
          text: this.$t("message.green_black_m_12"),
          value: "green_black_m_12",
          colors: ["#008000", "#0000FF", "#0000FF", "#0000FF", "#FF0000", "#000000"],
        },


      ]
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function (newValue) {
        this.selectedBelt = newValue;
      }
    }
  },
  created() {
    if (this.belts && this.belts.length > 0) {
      let newBelts = [];
      for (const b of this.belts) {
        for (const b2 of this.beltList) {
          if (b.value == b2.value) {
            newBelts.push(b2);
          }
        }
      }
      this.beltList = newBelts;
    }
  },
  methods: {
    emitChange(event) {
      this.$emit("input", event);
    }
  }
};
</script>

<style scoped></style>